import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

import {
    fetchSocialActionsByObjective,
    fetchSocialAdsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialDataByObjective,
} from 'services/social/duck';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import LinkClicksExpandModule from 'components/organisms/social/LinkClicksExpandModule';

class LinkClicksExpandContainer extends SocialObjectiveDashboardComponent {
    constructor(props) {
        super(props, 'LINK_CLICKS');
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialActionsByObjective(payload);
        this.props.fetchSocialAdsByObjective(payload);
        this.props.fetchSocialAdSetsByObjective(payload);
        this.props.fetchSocialCampaignsByObjective(payload);
        this.props.fetchSocialDataByObjective(payload);
    }

    render() {
        const { hide, showConversionRevenue, showSemCpconv } = this.props;
        return (
            !hide ?
                <LinkClicksExpandModule module={this.props.module}
                    xAxisLabel={this.props.xAxisLabel}
                    backfillBuckets={this.props.backfillBuckets}
                    layer={this.props.layer}
                    layerTwo={this.props.layerTwo}
                    entityMeta={this.props.entityMeta}
                    showSemCpconv={showSemCpconv}
                    showConversionRevenue={showConversionRevenue}
                    entityObjective={this.props.entityObjective}
                    entityObjectiveLabelCode={this.props.entityObjectiveLabelCode}
                /> : null
        );
    }
}

const mapStateToProps = state => ({
    entities: state.entities,
    entityMeta: state.entities.meta,
    layerTwo: state.layerTwo,
    module: state.social.facebook.objectives.LINK_CLICKS,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', []),
    showSemCpconv: get(state, 'entities.meta.meta.showSemCpconv', false),
    showConversionRevenue: get(state, 'entities.meta.meta.showConversionRevenue', false),
    entityObjective: get(state, 'entities.meta.meta.programmaticObjective.global', 'ecpa'),
    entityObjectiveLabelCode: get(state, 'entities.meta.meta.programmaticObjective.labelCode', null),
});

export default withRouter(
    connect(mapStateToProps, {
        fetchSocialActionsByObjective,
        fetchSocialAdsByObjective,
        fetchSocialAdSetsByObjective,
        fetchSocialCampaignsByObjective,
        fetchSocialDataByObjective,
    })(LinkClicksExpandContainer));



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/LinkClicksExpandContainer.js